import StepGenericTile from './StepGenericTile';

export default StepGenericTile;
